module.exports = __webpack_public_path__ + "static/media/chat.5e567f7d.svg";